import { Routes, Route } from 'react-router-dom';
import {
  Header,
  Hero,
  BlogOverview,
  Features,
  Pricing,
  FAQ,
  CTA,
  Footer
} from './components';
import { ProblemStatement } from './components/ProblemStatement';
import { ProductPillars } from './components/ProductPillars';
import { HowItWorks } from './components/HowItWorks';
import { ProductPage } from './components/ProductPage';
import { TransferPage } from './components/TransferPage';
import { DialogProvider } from './contexts/DialogContext';
import { DemoGate } from './components/demo/DemoGate';
import { DemoLibrary } from './components/demo/DemoLibrary';
import { DemoScenario } from './components/demo/DemoScenario';
import { PricingPage } from './components/PricingPage';
import { IndustryPage } from './components/IndustryPage';
import { SurveyPage } from './components/SurveyPage';
import V2Site from './v2/Site';

// Waitlist mode: simplified homepage for the live site — Hero, Blog, CTA only.
// Shows everything on localhost for development.
const isWaitlistMode = typeof window !== 'undefined'
  && !window.location.hostname.includes('localhost')
  && !window.location.hostname.includes('127.0.0.1')
  && !window.location.hostname.startsWith('192.168.');

function HomePage() {
  return (
    <>
      <Hero />
      {!isWaitlistMode && <ProblemStatement />}
      {!isWaitlistMode && <ProductPillars />}
      {!isWaitlistMode && <Features />}
      {!isWaitlistMode && <HowItWorks />}
      {!isWaitlistMode && <Pricing />}
      <BlogOverview />
      {!isWaitlistMode && <FAQ />}
      <CTA />
    </>
  );
}

export default function App() {
  return (
    <DialogProvider>
      <Routes>
        {/* Demo pages — immersive, no Header/Footer */}
        <Route path="/see-a-demo" element={<DemoGate />} />
        <Route path="/see-a-demo/library" element={<DemoLibrary />} />
        <Route path="/see-a-demo/:slug" element={<DemoScenario />} />

        {/* Legacy site (pre-v2), kept for comparison during the redesign */}
        <Route path="/legacy/*" element={
          <div className="bg-white">
            <Header waitlistMode={isWaitlistMode} />
            <main className="isolate">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/pricing" element={<PricingPage />} />
                <Route path="/product/:slug" element={<ProductPage />} />
                <Route path="/for/:slug" element={<IndustryPage />} />
              </Routes>
            </main>
            <Footer waitlistMode={isWaitlistMode} />
          </div>
        } />

        {/* Utility pages that keep the legacy chrome */}
        <Route path="/transfer/:token" element={<TransferPage />} />
        <Route path="/transfer" element={<TransferPage />} />
        <Route path="/survey" element={<SurveyPage />} />

        {/* Website v2 */}
        <Route path="*" element={<V2Site />} />
      </Routes>
    </DialogProvider>
  );
}
